import { createSlice } from "@reduxjs/toolkit";

const storedUser = localStorage.getItem("userInfo");
const storedExpiration = localStorage.getItem("expirationTime");

const isExpired =
  storedExpiration && new Date().getTime() > Number(storedExpiration);

// Remove expired session
if (isExpired) {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("expirationTime");
}

const initialState = {
  userInfo: !isExpired && storedUser ? JSON.parse(storedUser) : null,
};

const authSlice = createSlice({
  name: "auth",

  initialState,

  reducers: {
    setCredentials: (state, action) => {
      state.userInfo = action.payload;

      localStorage.setItem("userInfo", JSON.stringify(action.payload));

      const expirationTime = new Date().getTime() + 30 * 24 * 60 * 60 * 1000; // 30 days

      localStorage.setItem("expirationTime", expirationTime.toString());
    },

    logout: (state) => {
      state.userInfo = null;

      localStorage.removeItem("userInfo");
      localStorage.removeItem("expirationTime");
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

// Selectors
export const selectCurrentUser = (state) => state.auth.userInfo;

export const selectUserRole = (state) => state.auth.userInfo?.role;

export const selectCoachingCenter = (state) =>
  state.auth.userInfo?.coachingCenter;

export const selectIsProductAdmin = (state) =>
  state.auth.userInfo?.role === "productAdmin";

export default authSlice.reducer;
